import React from "react";
import { CodeBlock } from "react-code-block";
import { useCopyToClipboard } from "react-use";
import "@fortawesome/fontawesome-svg-core/styles.css";
import YouTube from "react-youtube";

function LegoL00JumpNavComponent({ code, language }) {
  code = `{/* L00jumpNav - section jump-link navigation */}
{/* Uses HashLink (react-router-hash-link) so the buttons smooth-scroll to each
    section. Put a matching id on each section's L4 heading, e.g.
    <div className="lego l004" id="generalNutrition">. */}
import { HashLink as Link } from "react-router-hash-link";

<div className="lego l00jumpNav legoMargin4">
    <nav className="jumpNavContainer">
        <Link smooth className="jumpNavButton" to="#generalNutrition">General Nutrition</Link>
        <Link smooth className="jumpNavButton" to="#gutHealth">Gut Health</Link>
        <Link smooth className="jumpNavButton" to="#kidneyHealth">Kidney Health</Link>
        <Link smooth className="jumpNavButton" to="#boneHealth">Bone Health</Link>
        <Link smooth className="jumpNavButton" to="#managingDiabetes">Managing Diabetes</Link>
        <Link smooth className="jumpNavButton" to="#helpfulWebsitesApps">Helpful Websites &amp; Apps</Link>
    </nav>
</div>
{/* End L00jumpNav */}`;
  language = "jsx";
  const [state, copyToClipboard] = useCopyToClipboard();

  const copyCode = () => {
    copyToClipboard(code);
  };

  return (
    <CodeBlock code={code} language={language}>
      <div className="relative">
        <CodeBlock.Code className="bg-black">
          <div className="table-row">
            <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
            <CodeBlock.LineContent className="table-cell">
              <CodeBlock.Token />
            </CodeBlock.LineContent>
          </div>
        </CodeBlock.Code>
        <div className="buttonContainer">
          <button className="btn btn-primary ml-auto" onClick={copyCode}>
            <i className="fa-solid fa-copy"></i>{" "}
            {state.value ? "Copied!" : "Copy code"}
          </button>
        </div>
      </div>
    </CodeBlock>
  );
}

export default LegoL00JumpNavComponent;
